import React, {useEffect, useState} from "react";
import "./style.scss";

export const CurrentWeightBMI = ({weight, height}) => {
  const [bmi, setBmi] = useState(24.0);
  useEffect(() => {
    const curWeightKG = weight.getWeightWithUnitKG();
    const curHeight = height.getHeightWithUnitM();
    if (curWeightKG && curHeight) {
      const bmiValue = curWeightKG / (curHeight * curHeight);
      setBmi(bmiValue.toFixed(1));
    } else {
      setBmi(0);
    }
  }, [weight])
  const renderText = () => {
    if (bmi <= 18) {
      return {
        color: '#2282E8',
        message: 'Take the first step toward your goals — we\'re with you!'
      };
    } else if (bmi <= 24) {
      return {
        color: '#3BBE5A',
        message: 'Wow, you look fantastic! Keep going!'
      };
    } else if (bmi <= 30) {
      return {
        color: '#ED6720',
        message: 'With a little more effort, you can make meaningful progress.'
      };
    } else {
      return {
        color: '#F93F1D',
        message: 'You\'ve got great potential — let\'s create a plan just for you.'
      };
    }
  };
  const {color, message} = renderText();


  return (
    <div className="current-weight-bmi">
      <div className={'current-weight-bmi-title'}>
        <div className={'current-weight-bmi-title-text'}>
          Your BMI:
        </div>
        <div className={'current-weight-bmi-title-bmi'} style={{color: color}}>
          {bmi}
        </div>
      </div>
      <div className={'current-weight-bmi-content'}>
        {message}
      </div>
    </div>
  );
};
